import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrink: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDrink"><Path fillRule="evenodd" clipRule="evenodd" d="M12.4992 3.35169L17.144 2.31951L16.8186 0.855225L10.9992 2.14843V6.00006H4.94922L6.04599 23.0001H17.9523L19.0491 6.00006H12.4992V3.35169ZM17.2234 11.0001H6.77492L6.54911 7.50006H17.4492L17.2234 11.0001Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDrink;
